<script setup>
import ManDept from '@/components/admin/member/ManDept.vue'
import ManJobTtl from '@/components/admin/member/ManJobTtl.vue'
import ManMemList from '@/components/admin/member/ManMemList.vue'
import AdmLayout from '@/pages/layout/AdmLayout.vue'
import { ref } from 'vue'
const submenus=ref(['man_member','man_admin','man_dept','man_jobtitle'])
</script>
<template>
  <AdmLayout :menutk="'managemembersusers'" :submenus="submenus">
    <v-tabs-window-item v-for="sm in submenus" :value="sm" class="overflow-y-auto">
      <ManMemList v-if="sm=='man_member'||sm=='man_admin'" :isadm="sm=='man_admin'"/>
      <ManDept v-if="sm=='man_dept'"/>
      <ManJobTtl v-if="sm=='man_jobtitle'"/>
    </v-tabs-window-item>
  </AdmLayout>
</template>
